import { render, staticRenderFns } from "./InfoMediaGeneric.vue?vue&type=template&id=ee2a6d58&scoped=true"
import script from "./InfoMediaGeneric.vue?vue&type=script&lang=js"
export * from "./InfoMediaGeneric.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee2a6d58",
  null
  
)

export default component.exports